<template>
  <div class="go-in">
    <div
      class="organizational"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
      v-loading="pageLoading"
    >
      <div style="box-sizing: border-box">
        <TitleTips
          :routerList="routerList"
          routeType="/showProduct"
          title="产品展示"
        />
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          font-size: 0.16rem;
        "
      >
        <el-row style="margin-bottom: 0.35rem">
          <el-col
            :span="24"
            style="display: flex; justify-content: space-between"
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size:16px
              "
            >
              <div style="white-space:nowrap">服务类别：</div>
              <el-select
                v-model="formData.parentProductType"
                @change="changeParentProductType"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in parentProductTypeList"
                  :label="item.name"
                  :key="index"
                  :value="item.code"
                ></el-option>
              </el-select>
              <div
                style="width: 0.2rem; background-color: #ccc; height: 0.01rem"
              ></div>
              <el-select
                v-loading="childProductLoading"
                @change="changeChildProductype"
                v-model="formData.productType"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in childProductType"
                  :label="item.name"
                  :key="index"
                  :value="item.code"
                ></el-option>
              </el-select>
            </div>
            <div
              style="
                width: 4.06rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <el-input
                placeholder="请输入产品名称"
                prefix-icon="el-icon-search"
                clearable
                v-model="formData.productName"
              >
              </el-input>
              <el-button
                :loading="searchLoading"
                type="primary"
                @click="searchData"
                style="margin-left: 0.1rem"
                >搜索</el-button
              >
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16" style="display: flex; flex-wrap: wrap">
          <el-col
            :span="6"
            v-for="(item, index) in pageData"
            :key="index"
            style="margin-bottom: 10px; cursor: pointer"
          >
            <div
              style="
                width: 100%;
                padding-top: 100%;
                height: 0;
                position: relative;
              "
            >
              <img
                :src="getUrl(item.imgUrl)"
                alt="pro"
                @click="clickItem(item)"
                style="
                  width: 100%;
                  height: 100%;
                  top: 0;
                  left: 0;
                  position: absolute;
                "
              />
            </div>

            <div class="item-name">{{ item.productName }}</div>
          </el-col>
        </el-row>
        <div
          style="margin: 0.2rem 0rem; font-size: 0.16rem; align-self: center"
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[12, 24, 36, 48, 60]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import http from '../utils/http';
import getFileUrl from '../utils/urlHelp';
export default {
  components: {
    TitleTips
  },
  name: 'ElectromechanicalComponents',
  data() {
    return {
      pageNum: 1,
      pageSize: 12,
      total: 0,
      searchLoading: false,
      pageLoading: false,
      childProductLoading: false,
      parentProductTypeList: [],
      childProductType: [],
      formData: {
        parentProductType: '',
        productType: '',
        productName: ''
      },
      pageData: [],
      routerList: []
    };
  },
  created() {
    http.post('/dictionary/getByCode', { groupType: 100 }).then(res => {
      this.parentProductTypeList = res.data;
      this.formData.parentProductType = res.data[0].code;
      // this.formData.parentProductType = res.data[0].code;
      this.getChildProductType();
      this.getData();
    });
  },
  methods: {
    getUrl(str) {
      return getFileUrl(str);
    },
    getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getData() {
      this.pageLoading = true;
      http
        .post('/reception/product/getProductPage', {
          ...this.formData,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          title: ''
        })
        .then(res => {
          this.pageData = res.rows;
          this.total = res.total;
        })
        .finally(() => {
          this.searchLoading = false;
          this.pageLoading = false;
        });
    },
    getChildProductType() {
      this.childProductLoading = true;
      http
        .post('/dictionary/getByCode', {
          code: '',
          parentCode: this.formData.parentProductType
        })
        .then(res => {
          this.childProductType = res.data;
        })
        .then(() => {
          this.childProductLoading = false;
        });
    },
    searchData() {
      this.searchLoading = true;
      this.pageNum = 1;
      this.getData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },
    changeParentProductType(val) {
      this.formData.productType = '';
      if (!val) {
        this.childProductType = [];
        return;
      }
      this.getData();

      this.getChildProductType();
      // this.childProductType= (this.parentProductTypeList.filter((item)=>item.productType===val))[0].subCategory
    },
    changeChildProductype() {
      this.getData();
    },
    clickItem(item) {
      this.$router.push({ path: `/showProduct/productDetail/${item.id}` });
    }
  },
  mounted() {
    this.routerList = this.$route.matched;
    const type = this.getQueryString('type');

    this.formData.productType = type;
  },

  watch: {}
};
</script>

<style lang="scss" scoped>
// * {
//   margin: 0;
//   padding: 0;
// }

.go-in {
  .organizational {
    width: 100%;
    box-sizing: border-box;
    padding: 0rem 1rem 0rem 1rem;
  }
}
.item-name {
  text-align: center;
  font-size: 16px;
  margin-top: 0.1rem;
}
</style>
